const ResourcesIndex = () => import(/* webpackChunkName: "communities" */ '@/pages/communities/ResourcesIndex.vue')
const Resources = () => import(/* webpackChunkName: "communities" */ '@/pages/communities/Resources.vue')
const ResourcesStandardsOptions = () => import(/* webpackChunkName: "communities" */ '@/pages/communities/ResourcesStandardsOptions.vue')
const StandardsOptionsPreview = () => import(/* webpackChunkName: "communities" */ '@/pages/communities/StandardsOptionsPreview.vue')
const ResourcesFaithBased = () => import(/* webpackChunkName: "communities" */ '@/pages/communities/ResourcesFaithBased.vue')

export default [
  {
    path: `/communities${process.env.VUE_APP_IS_PUBLIC ? '-public' : ''}/resources`,
    name: 'ResourcesIndex',
    component: ResourcesIndex,
    redirect: { name: 'Resources' },
    children: [
      {
        path: '',
        name: 'Resources',
        component: Resources
      },
      {
        path: 'standards-options',
        name: 'ResourcesStandardsOptions',
        component: ResourcesStandardsOptions
      },
      {
        path: 'standards-options/preview',
        name: 'StandardsOptionsPreview',
        component: StandardsOptionsPreview
      },
      {
        path: 'faith-based',
        name: 'ResourcesFaithBased',
        component: ResourcesFaithBased
      }]
  }
]
